import React from 'react';

import NrgComponent from './../NrgComponent.jsx';
import getIcon from '../../icons/svgController.js';
import getImgIcon from '../../icons/iconController.js';
export default class LargeIconListPanelRow extends NrgComponent {

  render() {
    var icon = this.props.icon;
    let Icon = getIcon(icon.iconName);

    return (
      <div className="item icon-col col-xs-16" data-scroll-item-once>
        <div className="icon">
          {icon.iconType === "IconImage" ?
            <img className="icon-image" src={getImgIcon(icon.iconName)} alt="content" />
            :
            <React.Fragment>{icon.iconName && <Icon viewBox={icon.iconName == 'graphs' ? "0 0 60 60" : "0 0 100 100"}></Icon>}</React.Fragment>
          }
        </div>
        <div className="text">
          <h4>{icon.description}</h4>
        </div>
      </div>
    );
  }
};
